import { App as AntApp, ConfigProvider, Spin } from 'antd';
import { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

const ManagementLayout = lazy(() =>
  import('./components/ManagementLayout').then((module) => ({
    default: module.ManagementLayout,
  })),
);
const ManagementAccessGate = lazy(() =>
  import('./components/ManagementAccessGate').then((module) => ({
    default: module.ManagementAccessGate,
  })),
);
const TokenExchangePage = lazy(() =>
  import('./components/TokenExchangePage').then((module) => ({
    default: module.TokenExchangePage,
  })),
);
const ActivityPage = lazy(() =>
  import('./pages/ActivityPage').then((module) => ({ default: module.ActivityPage })),
);
const LegacyItemRedirect = lazy(() =>
  import('./components/LegacyItemRedirect').then((module) => ({
    default: module.LegacyItemRedirect,
  })),
);
const DashboardPage = lazy(() =>
  import('./pages/ManagementPages').then((module) => ({ default: module.DashboardPage })),
);
const ProjectPage = lazy(() =>
  import('./pages/ProjectWorkspacePage').then((module) => ({ default: module.ProjectPage })),
);
const ReviewerPage = lazy(() =>
  import('./pages/ReviewerPage').then((module) => ({ default: module.ReviewerPage })),
);
const LandingPage = lazy(() =>
  import('./pages/FoundationPages').then((module) => ({ default: module.LandingPage })),
);
const NotFoundPage = lazy(() =>
  import('./pages/FoundationPages').then((module) => ({ default: module.NotFoundPage })),
);
const SessionEndedPage = lazy(() =>
  import('./pages/FoundationPages').then((module) => ({ default: module.SessionEndedPage })),
);

function RouteFallback() {
  return (
    <div className="center-state" aria-label="Memuat halaman">
      <Spin size="large" />
    </div>
  );
}

export function App() {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#176b87',
          borderRadius: 10,
          colorBgLayout: '#f3f6f8',
        },
      }}
    >
      <AntApp>
        <BrowserRouter>
          <Suspense fallback={<RouteFallback />}>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/manage/:token" element={<TokenExchangePage mode="management" />} />
              <Route path="/manage" element={<ManagementAccessGate />}>
                <Route element={<ManagementLayout />}>
                  <Route index element={<DashboardPage />} />
                  <Route path="projects/:projectId" element={<ProjectPage />} />
                  <Route path="items/:itemId" element={<LegacyItemRedirect />} />
                  <Route path="activity" element={<ActivityPage />} />
                </Route>
              </Route>
              <Route path="/review/:token" element={<TokenExchangePage mode="review" />} />
              <Route path="/review" element={<ReviewerPage />} />
              <Route path="/session-ended" element={<SessionEndedPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </AntApp>
    </ConfigProvider>
  );
}
